import { c as _c } from "react/compiler-runtime";
import { IcoInfo16 } from '@onefootprint/icons';
import type { BeneficialOwnerStatus, EntityStatus, PrivateBusinessOwner } from '@onefootprint/request-types/dashboard';
import { Badge } from '@onefootprint/ui';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import StatusBadge from '@/components/status-badge';
export type ContentProps = {
  explanationMessage?: string;
  businessOwners: PrivateBusinessOwner[];
};
const BusinessOwnersField = t0 => {
  const $ = _c(24);
  const {
    businessOwners,
    explanationMessage
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "vault.bos"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("business-details", t1);
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[1] !== businessOwners || $[2] !== t) {
    const visibleOwners = businessOwners.filter(_temp);
    let t6;
    if ($[7] !== t) {
      t6 = t7 => {
        const {
          ownershipStake: stake,
          kind,
          source
        } = t7;
        const isPrimary = kind === "primary" && source !== "tenant";
        if (isPrimary) {
          return stake ? t(_temp2, {
            stake
          }) : t(_temp3);
        }
        return stake ? t(_temp4, {
          stake
        }) : "";
      };
      $[7] = t;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    const getHintText = t6;
    t5 = "flex flex-col gap-6";
    t2 = "grid gap-4";
    if ($[9] !== t) {
      t3 = t(_temp5);
      $[9] = t;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    let t7;
    if ($[11] !== getHintText || $[12] !== t) {
      t7 = (businessOwner, index) => {
        const isPrimary_0 = businessOwner.kind === "primary";
        return <li className="flex flex-wrap justify-between gap-x-4 gap-y-1 md:flex-nowrap md:gap-0" key={businessOwner.fpId || index}><div className="flex flex-col gap-2"><div className="flex flex-wrap items-center gap-1 md:flex-nowrap"><p className="text-body-2 text-tertiary">{t(_temp6)}</p><div className="flex gap-1">{isPrimary_0 ? <Badge variant="neutral">{t(_temp7)}</Badge> : null}<BoStatusBadge status={businessOwner.boStatus} /></div>{businessOwner.fpId && <ViewProfileLink href={`/users/${businessOwner.fpId}`} />}</div><p className="text-caption-2 text-secondary">{getHintText(businessOwner)}</p></div><p className="text-body-2 text-primary text-center break-words min-w-0 md:min-w-auto md:h-6" data-dd-privacy="mask">{businessOwner.name}</p></li>;
      };
      $[11] = getHintText;
      $[12] = t;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    t4 = visibleOwners.map(t7);
    $[1] = businessOwners;
    $[2] = t;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t6 = <ul className={t2} aria-label={t3}>{t4}</ul>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== explanationMessage) {
    t7 = explanationMessage ? <OwnershipExplanation value={explanationMessage} /> : null;
    $[18] = explanationMessage;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
const BoStatusBadge = t0 => {
  const $ = _c(7);
  const {
    status
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "vault.bos"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("business-details", t1);
  if (!status) {
    return null;
  }
  if (status !== "awaiting_kyc") {
    const t2 = status as EntityStatus;
    let t3;
    if ($[1] !== t2) {
      t3 = <StatusBadge status={t2} />;
      $[1] = t2;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp8);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <Badge variant="info">{t2}</Badge>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
const ViewProfileLink = t0 => {
  const $ = _c(7);
  const {
    href
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "vault.bos"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("business-details", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>·</span>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp9);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== href || $[5] !== t3) {
    t4 = <>{t2}<p className="text-label-2 text-accent"><Link href={href}>{t3}</Link></p></>;
    $[4] = href;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
const OwnershipExplanation = t0 => {
  const $ = _c(11);
  const {
    value
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "vault.bos.stakeExplanation"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("business-details", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IcoInfo16 />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp10);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex items-center gap-2">{t2}<p className="text-label-2 text-primary">{t3}</p></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== value) {
    t5 = <p className="text-body-2 text-secondary">{value}</p>;
    $[6] = value;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="flex flex-col gap-2 bg-primary border border-solid border-tertiary rounded p-3">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default BusinessOwnersField;
function _temp(t0) {
  const {
    ownershipStake
  } = t0;
  return ownershipStake != null;
}
function _temp2($) {
  return $.hint.primaryWithStake;
}
function _temp3($_0) {
  return $_0.hint.primaryNoStake;
}
function _temp4($_1) {
  return $_1.hint.genericStake;
}
function _temp5($_2) {
  return $_2.listTitle;
}
function _temp6($_3) {
  return $_3.label;
}
function _temp7($_4) {
  return $_4.primary;
}
function _temp8($) {
  return $.status.awaitingKyc;
}
function _temp9($) {
  return $.link;
}
function _temp10($) {
  return $.title;
}